import React, { useEffect } from "react";
import * as Yup from "yup";
import { Button, OverlayTrigger, Col, Tooltip } from "react-bootstrap";
import { BsFillArrowLeftSquareFill } from "react-icons/bs";
import TelaTipoDemonstrativo from "./TelaTipoDemonstrativo";
import TelaImportacao from "./TelaImportacao";
import FormDemonstrativos from "./FormDemonstrativos";
import useMontarLogica from "./hooks/useMontarLogica";
import useVerificaResultado from "./hooks/useVerificaResultado";
import useSomenteConsultaOs from "../hooks/useSomenteConsultaOs";

const validationSchema = Yup.object().shape({
  sqAcaoFiscal: Yup.string().default(""),
  sqItemOcorrencia: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ListaDemonstrativo = ({ dadosOs, dadosOcorrencia, history, tipoTela }) => {
  const { montarLogica, importarPlanilha, incluirRegistro, mostrarTelaInicial, mostrarLista, setMostrarLista } =
    useMontarLogica();

  const { verificaResultado, existe } = useVerificaResultado({ sqAcaoFiscal: dadosOs.acaoFiscal });

  const somenteConsulta = useSomenteConsultaOs();

  useEffect(() => {
    if (dadosOs.acaoFiscal !== null && dadosOs.acaoFiscal !== "") {
      verificaResultado();
    }
  }, [dadosOs.acaoFiscal, verificaResultado]);

  useEffect(() => {
    if (mostrarTelaInicial) {
      setMostrarLista(true);
    }
  }, [montarLogica, mostrarTelaInicial, setMostrarLista]);

  const voltarListagem = () => {
    montarLogica(1);
    setMostrarLista(true);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card shadow mb-4">
          <div className="card-header pt-3 pb-3 pb-0 flex-row w-100">
            <div className="row d-flex flex-row">
              <Col classeName="form-inline justify-content-start d-flex align-items-center">
                <OverlayTrigger placement="top" overlay={<Tooltip>Voltar tela </Tooltip>}>
                  <BsFillArrowLeftSquareFill
                    size="20"
                    color="#E37023"
                    onClick={() => {
                      montarLogica(1);
                      setMostrarLista(!mostrarLista);
                      // setMostrarLista((prev) => !prev);
                    }}
                    className="mr-3"
                  />
                </OverlayTrigger>

                <span className="font-weight-bold text-primary">
                  Demonstrativo tipo <strong> {dadosOcorrencia.nmDetalhamento} </strong>{" "}
                </span>
              </Col>

              <spam hidden={importarPlanilha || incluirRegistro}>
                {!somenteConsulta &&
                  dadosOcorrencia?.sqModeloImportacao > 0 &&
                  dadosOcorrencia?.sqModeloImportacao !== null && (
                    <Button
                      className="btn btn-primary btn-md mr-2"
                      onClick={() => {
                        montarLogica(2);
                      }}
                      disabled={existe === "S"}
                    >
                      Importar planilha
                    </Button>
                  )}
              </spam>

              <spam hidden={importarPlanilha || incluirRegistro}>
                {!somenteConsulta && dadosOcorrencia?.fgExtrato === "N" && (
                  <Button
                    className="btn btn-primary btn-md mr-2"
                    onClick={() => {
                      montarLogica(3);
                    }}
                    disabled={existe === "S"}
                  >
                    Incluir Registro
                  </Button>
                )}
              </spam>
            </div>
          </div>

          {mostrarTelaInicial && mostrarLista && (
            <div className="card-body">
              <TelaTipoDemonstrativo
                tipoDetalhamento={dadosOcorrencia.tipoDetalhamento}
                sqItemOcorrencia={dadosOcorrencia.sqItemOcorrencia}
                sqAcaoFiscal={dadosOs.acaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
                history={history}
              />
            </div>
          )}

          {importarPlanilha && (
            <div className="card-body">
              <TelaImportacao
                sqAcaoFiscal={dadosOs.acaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
                onUploadSuccess={() => {
                  montarLogica(1);
                }}
              />
            </div>
          )}

          {incluirRegistro && (
            <FormDemonstrativos
              tipoDetalhamento={dadosOcorrencia.tipoDetalhamento}
              sqItemOcorrencia={dadosOcorrencia.sqItemOcorrencia}
              sqAcaoFiscal={dadosOs.acaoFiscal}
              dadosOcorrencia={dadosOcorrencia}
              tipoTela={tipoTela}
              voltarListagem={() => voltarListagem()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ListaDemonstrativo;
